export function mapUserApiToModel(userData) {
    const result = { ...userData };

    if (result?.org?.members?.length > 0) {
        result.org.members = result.org.members.map(m => {
            return {
                ...m,
                email: m.userEmail,
                createTs: +m.createTs,
                approvedTs: +m.approvedTs,
            };
        });
    }

    return result;

}